class AdvertExperiencePageController {
  constructor(AdvertService, AlertService, LoaderService) {
    this.AdvertService = AdvertService;
    this.AlertService = AlertService;
    this.LoaderService = LoaderService;
  }

  $onInit() {
    var self = this;
    self.adverts = [];
    self.LoaderService.start();
    self.AdvertService
      .getAllExperienceCarouselAdverts()
      .then(adverts => (self.adverts = adverts))
      .catch(error =>
        self.AlertService.error('There was a problem getting the Adverts')
      )
      .finally(() => self.LoaderService.stop());
  }

  orderChanged(index) {
    var self = this;
    self.adverts.splice(index, 1);
    self.LoaderService.start();
    self.AdvertService
      .reorder(self.adverts, 'Experience')
      .then(() => {
        for (var i = 0; i < self.adverts.length; i++) {
          // We injected AdvertService into each advert due to lost scope in
          // dnd custom sorting directive
          self.adverts[i].advertService = self.AdvertService;
        }
        self.AlertService.success('Advert order changed successfully');
      })
      .catch(error =>
        self.AlertService.error('There was a problem getting the Adverts')
      )
      .finally(() => self.LoaderService.stop());
  }
}
AdvertExperiencePageController.$inject = [
  'AdvertService',
  'AlertService',
  'LoaderService'
];
export default AdvertExperiencePageController;
